import { getFormatDate } from '@src/Common/Constants/getFormatDate';
import React from 'react';

import { getLimitText } from '@src/Common/Constants/getLimitText';
import { EventIcon, GameIcon, RepoIcon } from '@src/Components/Icons';

import { IMapCoordinateGrouped } from '@src/Domain/DUMEvents/DUMEvents.type';
import { ArrowRight } from './Icons/ArrowRight';
import styles from './PopupCustomMultiple.module.scss';

const handleIconTitle = (type: string | undefined) => {
  if (type === 'dum' || type === 'report') return <EventIcon />;
  if (type === 'casefile') return <RepoIcon />;
  return <GameIcon />;
};

const checkCoordinate = (value?: number) => {
  if (value) return Number(value).toFixed(6);
  return 0;
};

const PopupCustomMultiple: React.FC<IMapCoordinateGrouped> = ({
  locationDetail = 'Ontario, Canada, Cochrane District',
  coordinate = [50.505961, -79.760919],
  data,
  onClickItem
}) => {
  return (
    <div className={styles['Container']} data-testid="popup-custom">
      <div className={styles['Header']}>
        <p className={styles['Location']}>
          {locationDetail} <span>/ </span>
          <span>
            {`${checkCoordinate(coordinate[0])}, ${checkCoordinate(
              coordinate[1]
            )}`}
          </span>
        </p>
      </div>
      {data.map((val, key) => {
        const isEven = key % 2 === 0;
        return (
          <div
            key={val.latlon.join() + val.globalEventId}
            className={
              styles['ContainerItem'] + ' ' + styles[isEven ? 'Even' : 'Odd']
            }
            onClick={() => {
              if (onClickItem && val.globalEventId) {
                onClickItem(key);
              }
            }}
          >
            <div className={styles['TopContent']}>
              <div className={styles['DetailContainer']}>
                <div className={styles['Icon']}>
                  {handleIconTitle(val.type)}
                </div>
                <p className={styles['Investigation']}>
                  {getLimitText(200, val.investigation ?? '')}
                </p>
              </div>
              <div className={styles['Arrow']}>
                <ArrowRight />
              </div>
            </div>
            <div className={styles['BottomContent']}>
              <div className={styles['DateContainer']}>
                <p>
                  Event Date:
                  {val.date ? getFormatDate(val.date, false, false, '-') : '-'}
                </p>
              </div>
              {process.env.DISPLAY_AUTHOR === 'TRUE' && (
                <div className={styles['ProfileContainer']}>
                  <div className={styles['Image']}>
                    <img
                      src={val.authorImageUrl ?? 'assets/profile-mobile.png'}
                      alt="profile-picture"
                    />
                  </div>
                  <p className={styles['username']}>{val.author}</p>
                </div>
              )}
            </div>
          </div>
        );
      })}
      <div className={styles['FooterContent']}>
        <p
          className={styles['read-more']}
          onClick={() => {
            if (onClickItem) {
              onClickItem(0);
            }
          }}
        >
          Click the point to read more
        </p>
      </div>
    </div>
  );
};

export default PopupCustomMultiple;
